import { parseDate, roundToXDecimals } from '@ais-ui/utils';
import { QueryPointResult } from './extractTargetInfo';

export interface VirtualAtonTargetInfo {
  assignedMode: string;
  atonType: string;
  country: string;
  flag: string;
  lastAisReport: Date | null;
  lastAisLatitude: string;
  lastAisLongitude: string;
  lastAisSatLatitude: string;
  lastAisSatLongitude: string;
  lastAisSatReport: Date | null;
  latitudeDegrees: string;
  longitudeDegrees: string;
  latitude: number;
  longitude: number;
  length: string;
  mmsi: string;
  name: string;
  offPosition: string;
  state: string;
  status: string;
  targetType: string;
  width: string;
}

const desiredTargetIds: string[] = [
  'assigned_mode',
  'country',
  'flag',
  'lastaisreport',
  'lastaissatreport',
  'length',
  'mmsi',
  'name',
  'off_position',
  'state',
  'status',
  'type',
  'width',
];

const desiredTargetNames: string[] = [
  'Last AIS Latitude',
  'Last AIS Longitude',
  'Last AIS-Sat Latitude',
  'Last AIS-Sat Longitude',
  'Latitude',
  'Longitude',
];

export function extractVirtualAtonTargetInfos(
  result: QueryPointResult
): VirtualAtonTargetInfo[] {
  const VirtualAtonTargetInfos: VirtualAtonTargetInfo[] = [];
  for (const target of result.targetInfo) {
    const rawVirtualAtonTargetInfo: { [key: string]: string } = {};
    for (const target_value of target.values) {
      // Here we map values by their ID
      if (desiredTargetIds.includes(target_value.id)) {
        rawVirtualAtonTargetInfo[target_value.id] = target_value.value;
      }
      // Some values have the same ID so here we map those by the NAME instead
      if (desiredTargetNames.includes(target_value.name)) {
        rawVirtualAtonTargetInfo[target_value.name] = target_value.value;
      }
    }
    const mmsi = target['mmsi'] || rawVirtualAtonTargetInfo['MMSI'];

    const VirtualAtonInfo: VirtualAtonTargetInfo = {
      assignedMode: rawVirtualAtonTargetInfo['assigned_mode'],
      atonType: rawVirtualAtonTargetInfo['type'],
      country: rawVirtualAtonTargetInfo['country'],
      flag: rawVirtualAtonTargetInfo['flag'],
      lastAisReport: parseDate(rawVirtualAtonTargetInfo['lastaisreport']),
      lastAisLatitude: rawVirtualAtonTargetInfo['Last AIS Latitude'],
      lastAisLongitude: rawVirtualAtonTargetInfo['Last AIS Longitude'],
      lastAisSatLatitude: rawVirtualAtonTargetInfo['Last AIS-Sat Latitude'],
      lastAisSatLongitude: rawVirtualAtonTargetInfo['Last AIS-Sat Longitude'],
      lastAisSatReport: parseDate(rawVirtualAtonTargetInfo['lastaissatreport']),
      latitudeDegrees: rawVirtualAtonTargetInfo['Latitude'],
      longitudeDegrees: rawVirtualAtonTargetInfo['Longitude'],
      latitude: target['lat']
        ? roundToXDecimals(target['lat'], 4)
        : target['lat'],
      longitude: target['lon']
        ? roundToXDecimals(target['lon'], 4)
        : target['lon'],
      length: rawVirtualAtonTargetInfo['length'],
      mmsi: mmsi,
      name: rawVirtualAtonTargetInfo['name'],
      offPosition: rawVirtualAtonTargetInfo['off_position'],
      state: rawVirtualAtonTargetInfo['state'],
      status: rawVirtualAtonTargetInfo['status'],
      targetType: target['type'],
      width: rawVirtualAtonTargetInfo['width'],
    };
    VirtualAtonTargetInfos.push(VirtualAtonInfo);
  }

  return VirtualAtonTargetInfos;
}
